import { useEffect } from 'react'
import type { RefObject } from 'react'
import { useLatest } from './useLatest.ts'

/** Focuses an element once, when the component mounts: the ref's, or the one `target` finds. */
export const useFocusOnMount = (target: RefObject<HTMLElement | null> | (() => HTMLElement | null | undefined)) => {
  const latest = useLatest(target)
  useEffect(() => {
    const current = latest.current
    const element = typeof current === 'function' ? current() : current.current
    element?.focus()
  }, [latest])
}
